/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './staff-calendar.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../$$_gendir/node_modules/ap-angular2-fullcalendar/src/calendar/calendar.ngfactory';
import * as import3 from 'ap-angular2-fullcalendar/src/calendar/calendar';
import * as import4 from '@angular/router';
import * as import5 from '../../shared/ui/mobile-header/mobile-header.component.ngfactory';
import * as import6 from '../../../../app/shared/ui/mobile-header/mobile-header.component';
import * as import7 from '../../../../app/booking-management/booking-header/booking-header.service';
import * as import8 from '../user-header/user-header.component.ngfactory';
import * as import9 from '../../../../app/user-management/user-header/user-header.component';
import * as import10 from '../../../../app/shared/router/linkhelper';
import * as import11 from '@angular/material';
import * as import12 from '@angular/forms';
import * as import13 from '@angular/common';
import * as import14 from '../../../../app/user-management/staff-calendar/staff-calendar.component';
import * as import15 from '../../../../app/spinner/spinner.service';
import * as import16 from '../../../../app/api/user.service';
const styles_StaffCalendarComponent:any[] = [import0.styles];
export const RenderType_StaffCalendarComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_StaffCalendarComponent,
  data: {}
}
);
function View_StaffCalendarComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),12,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['STAFF AVAILABILITY'])),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'angular2-fullcalendar',[[
        'id',
        'mycal'
      ]
    ],(null as any),(null as any),(null as any),import2.View_CalendarComponent_0,import2.RenderType_CalendarComponent)),
    import1.ɵdid(4243456,[
      [
        1,
        4
      ]
      ,
      [
        'mycal',
        4
      ]

    ]
      ,0,import3.CalendarComponent,[import1.ElementRef],{options: [
        0,
        'options'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'button',[[
        'id',
        'staff-availability'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,9).onClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import4.RouterLink,[
      import4.Router,
      import4.ActivatedRoute,
      [
        8,
        (null as any)
      ]
      ,
      import1.Renderer,
      import1.ElementRef
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵpad(3),
    (l()(),import1.ɵted((null as any),['ADD STAFF AVAILABILITY'])),
    (l()(),import1.ɵted((null as any),['\n      ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.calendarOptions;
    ck(v,6,0,currVal_0);
    const currVal_1:any = ck(v,10,0,'/user-management/',(0 - 3),'staff-availability');
    ck(v,9,0,currVal_1);
  },(null as any));
}
export function View_StaffCalendarComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(671088640,1,{myCal: 0}),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-mobile-header',[
      [
        'backLink',
        '/booking-management'
      ]
      ,
      [
        'title',
        'USER PROFILE'
      ]

    ]
    ,(null as any),(null as any),(null as any),import5.View_MobileHeaderComponent_0,import5.RenderType_MobileHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import6.MobileHeaderComponent,[
      import4.Router,
      import7.BookingHeaderService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      backLink: [
        1,
        'backLink'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'section',[[
        'id',
        'submenu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(16777216,(null as any),(null as any),2,'app-user-header',[[
        'id',
        'main-submenu-links'
      ]
    ],(null as any),(null as any),(null as any),import8.View_UserHeaderComponent_0,import8.RenderType_UserHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import9.UserHeaderComponent,[
      import10.LinkAuth,
      import4.Router,
      import11.MdDialog,
      import1.ViewContainerRef
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),14,'div',[[
        'id',
        'page-common'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'main',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),8,'form',[
      [
        'class',
        'common-form reduced-top'
      ]
      ,
      [
        'novalidate',
        ''
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,17).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import1.ɵnov(v,17).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(16384,(null as any),0,import12.ɵbf,([] as any[]),(null as any),(null as any)),
    import1.ɵdid(16384,(null as any),0,import12.NgForm,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    import1.ɵprd(2048,(null as any),import12.ControlContainer,(null as any),[import12.NgForm]),
    import1.ɵdid(16384,(null as any),0,import12.NgControlStatusGroup,[import12.ControlContainer],(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StaffCalendarComponent_1)),
    import1.ɵdid(16384,(null as any),0,import13.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['     \n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import14.StaffCalendarComponent = v.component;
    const currVal_0:any = 'USER PROFILE';
    const currVal_1:any = '/booking-management';
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_9:any = (co.displayCalendar && co.updateCalendar);
    ck(v,22,0,currVal_9);
  },(ck,v) => {
    const currVal_2:any = import1.ɵnov(v,19).ngClassUntouched;
    const currVal_3:any = import1.ɵnov(v,19).ngClassTouched;
    const currVal_4:any = import1.ɵnov(v,19).ngClassPristine;
    const currVal_5:any = import1.ɵnov(v,19).ngClassDirty;
    const currVal_6:any = import1.ɵnov(v,19).ngClassValid;
    const currVal_7:any = import1.ɵnov(v,19).ngClassInvalid;
    const currVal_8:any = import1.ɵnov(v,19).ngClassPending;
    ck(v,15,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  });
}
function View_StaffCalendarComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-staff-calendar',([] as any[]),(null as any),(null as any),(null as any),View_StaffCalendarComponent_0,RenderType_StaffCalendarComponent)),
    import1.ɵdid(114688,(null as any),0,import14.StaffCalendarComponent,[
      import15.SpinnerService,
      import4.ActivatedRoute,
      import16.UserService,
      import4.ActivatedRoute,
      import4.Router
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const StaffCalendarComponentNgFactory:import1.ComponentFactory<import14.StaffCalendarComponent> = import1.ɵccf('app-staff-calendar',import14.StaffCalendarComponent,View_StaffCalendarComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/user-management/staff-calendar/staff-calendar.component.ngfactory.ts